import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

const AgricultureCaseStudies = () => {
    return (
        <div className="section-py">
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12 mb-10">
                    <div className="lg:col-span-12">
                        <h2 className="text-primary_one mb-0">Case Studies on Agriculture Software Development Services</h2>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 mb-10">
                    <div className="lg:col-span-12">
                        <div className="border rounded-10 bg-grey lg:p-10 md:p-10 p-4 flex lg:flex-nowrap md:flex-nowrap flex-wrap gap-7 lg:gap-0 md:gap-0">
                            <div className="lg:pr-7 md:pr-7 pr-0">
                                <div className="flex items-center mb-3">
                                    <div className="pr-2">
                                        <Image
                                            src="/img/icons/ic-cost-delay.svg"
                                            alt="Cut Inventory Costs"
                                            title="Cut Inventory Costs"
                                            height={40}
                                            width={40}
                                        />
                                    </div>
                                    <p className="fs-xxl font-bold mb-0 text-primary_one">28%</p>
                                </div>
                                <p className="font-semibold text-primary_one mb-3">
                                    Cut Inventory Costs by 28% with a Custom Farm Inventory System
                                </p>
                                <p className="fs-md mb-0">
                                    A mid-sized seed production company struggled with stock tracking and seasonal overstocks.
                                    Moweb built a custom inventory management solution with real-time alerts and usage analytics,
                                    resulting in a 28% reduction in input waste across two harvest cycles.
                                </p>
                            </div>
                            <div className="pr-0 pl-0 lg:pr-7 md:pr-7 lg:pl-7 md:pl-7 border-r-0 border-l-0 lg:border-r lg:border-l md:border-r md:border-l">
                                <div className="flex items-center mb-3">
                                    <div className="pr-2">
                                        <Image
                                            src="/img/icons/ic-accuracy.svg"
                                            alt="Increased Crop Yield"
                                            title="Increased Crop Yield"
                                            height={40}
                                            width={40}
                                        />
                                    </div>
                                    <p className="fs-xxl font-bold mb-0 text-primary_one">35%</p>
                                </div>
                                <p className="font-semibold text-primary_one mb-3">
                                    Increased Crop Yield Forecast Accuracy by 35% Using AI Models
                                </p>
                                <p className="fs-md mb-0">
                                    An agribusiness client lacked reliable methods to predict output across varied soil types. We
                                    developed a precision farming app powered by machine learning and soil data
                                    integration—helping them plan better and reduce yield surprises by 35%.
                                </p>
                            </div>
                            <div className="pl-0 lg:pl-7 md:pl-7">
                                <div className="flex items-center mb-3">
                                    <div className="pr-2">
                                        <Image
                                            src="/img/icons/ic-accuracy.svg"
                                            alt="Drone Integration"
                                            title="Drone Integration"
                                            height={40}
                                            width={40}
                                        />
                                    </div>
                                    <p className="fs-xxl font-bold mb-0 text-primary_one">1,500+</p>
                                </div>
                                <p className="font-semibold text-primary_one mb-3">
                                    Saved 1,500+ Manual Hours per Season with Drone Integration
                                </p>
                                <p className="fs-md mb-0">
                                    For a large-scale vegetable producer, manual crop scouting was time-intensive. We created a
                                    drone automation platform that enabled aerial scanning, disease detection, and health
                                    mapping—cutting over 1,500 hours of manual fieldwork each season.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-12">
                        <h2 className="mb-3 text-primary_one">Want to See What We Can Build for You?</h2>
                        <p className="mb-3">
                            Let&apos;s explore how custom agriculture software services can unlock measurable gains for your farm
                            or agribusiness.
                        </p>
                        <div>
                            <Link
                                href="/contact-us"
                                className="btn btn-primary bg-[#00B050] border-[#00B050] hover:border-[#00B050]"
                            >
                                {'Talk to an Expert'}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default AgricultureCaseStudies;
